import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { imgCut } from '@/utils/filters';
var getImageData = function getImageData(src) {
  var img = new Image();
  img.crossOrigin = 'Anonymous';
  img.src = src;
  return new Promise(function (resolve, reject) {
    img.onload = function () {
      var w = this.width;
      var h = this.height;

      // 创建画布
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      // document.body.prepend(canvas)
      // 绘制图片在画布上
      var context = canvas.getContext('2d');
      context.drawImage(this, 0, 0, w, h);

      // onload 内

      var pxArr = context.getImageData(0, 0, w, h).data;
      var r = 0,
        g = 0,
        b = 0;
      // 取所有像素的平均值
      for (var row = 0; row < img.height; row++) {
        for (var col = 0; col < img.width; col++) {
          r += pxArr[(img.width * row + col) * 4];
          g += pxArr[(img.width * row + col) * 4 + 1];
          b += pxArr[(img.width * row + col) * 4 + 2];
        }
      }

      // 求取平均值
      r /= img.width * img.height;
      g /= img.width * img.height;
      b /= img.width * img.height;

      // 将最终的值取整
      r = Math.round(r);
      g = Math.round(g);
      b = Math.round(b);
      resolve([r, g, b]);
    };
  });
};
export var getColor = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_src, index) {
    var src;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          src = imgCut(_src, 88 * 3, 118 * 3);
          return _context.abrupt("return", Promise.resolve(getImageData(src)).then(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 3),
              r = _ref3[0],
              g = _ref3[1],
              b = _ref3[2];
            return [r, g, b];
          }).catch(function (err) {
            console.warn(err);
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getColor(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// 将 RGB 颜色元组转换为 HSB 格式。
export var RGBToHSB = function RGBToHSB(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  var v = Math.max(r, g, b),
    n = v - Math.min(r, g, b);
  var h = n === 0 ? 0 : n && v === r ? (g - b) / n : v === g ? 2 + (b - r) / n : 4 + (r - g) / n;
  return [60 * (h < 0 ? h + 6 : h), v && n / v * 100, v * 100];
};